import { render, staticRenderFns } from "./CompanyEnableNewMenu.vue?vue&type=template&id=da1d5a12&scoped=true"
import script from "./CompanyEnableNewMenu.vue?vue&type=script&lang=js"
export * from "./CompanyEnableNewMenu.vue?vue&type=script&lang=js"
import style0 from "./CompanyEnableNewMenu.vue?vue&type=style&index=0&id=da1d5a12&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1d5a12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da1d5a12')) {
      api.createRecord('da1d5a12', component.options)
    } else {
      api.reload('da1d5a12', component.options)
    }
    module.hot.accept("./CompanyEnableNewMenu.vue?vue&type=template&id=da1d5a12&scoped=true", function () {
      api.rerender('da1d5a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/CompanyEnableNewMenu.vue"
export default component.exports